import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask'
import classNames from 'classnames'
import * as fields from '../../../constants/fields'
import InputErrorIcon from '../Icons/InputErrorIcon'
import Text from '../Text/Text'
import styles from './textField.module.scss'

const TextField = (props) => {
  const {
    field: { name, id, onChange, value } = {},
    form: { errors = {} } = {},
    type,
    mask,
    full,
    margin,
    variation,
    placeholder,
    alwaysShowMask,
    label,
    transform
  } = props

  const [isActive, setIsActive] = useState(false)

  const hasError = Object.prototype.hasOwnProperty.call(errors, name)

  useEffect(() => {
    if (hasError) setIsActive(true)
  }, [hasError])

  useEffect(() => {
    if (value !== '') setIsActive(true)
  }, [value])

  const inputProps = {}

  switch (mask) {
    case 'authCode':
      inputProps.mask = fields.AUTH_CODE_MASK
      break

    case 'cpf':
      inputProps.mask = fields.CPF_MASK
      break

    case 'cnpj':
      inputProps.mask = fields.CNPJ_MASK
      break

    case 'phone':
      inputProps.mask = fields.PHONE_MASK
      break

    default:
      inputProps.mask = null
  }

  const textFieldClass = classNames(styles.field, {
    [styles.full]: full,
    [styles[variation]]: variation,
    [styles.hasError]: hasError
  })

  const textFieldStyle = {}

  if (margin) textFieldStyle.margin = margin

  function handleChange(e) {
    const newEvent = { ...e }
    const text = e.target.value

    if (transform) newEvent.target.value = transform(text)

    if (onChange) onChange(newEvent)
  }
  return (
    <div className={textFieldClass} style={textFieldStyle}>
      <div className={styles.containerInput}>
        <InputMask
          /* eslint-disable-next-line react/jsx-props-no-spreading */
          {...inputProps}
          id={id}
          type={type}
          name={name}
          onChange={handleChange}
          value={value}
          placeholder={placeholder}
          autoComplete="off"
          alwaysShowMask={alwaysShowMask}
        />
        <div className={styles.iconStatus}>
          <div className={styles.hasErrorIcon}>
            <InputErrorIcon />
          </div>
        </div>

        <label
          className={isActive ? styles.labelActive : styles.labelNotActive}
        >
          {label}
        </label>
      </div>

      {hasError && (
        <div className={styles.error}>
          <Text font="custom" size="xxs" color="error" value={errors[name]} />
        </div>
      )}
    </div>
  )
}

TextField.defaultProps = {
  field: undefined,
  form: undefined,
  type: 'text',
  label: null,
  mask: null,
  full: false,
  margin: null,
  variation: null,
  placeholder: null,
  alwaysShowMask: false,
  transform: null
}

TextField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({})
  }),
  type: PropTypes.string,
  label: PropTypes.string,
  mask: PropTypes.string,
  full: PropTypes.bool,
  margin: PropTypes.bool,
  variation: PropTypes.string,
  placeholder: PropTypes.string,
  alwaysShowMask: PropTypes.bool,
  transform: PropTypes.func
}

export default TextField
